const orderFieldsNonConfirmed = {
  mainFields: [
    "Entity Name",
    "Engagement Code",
    "Activity ID",
    "Analyser Type",
    "Period of Testing",
    "ERP Name",
    "ERP Version",
    "Data Processing Team",
    "Data Processing Server location",
    "Analyzer Server Location",
  ],
  dateFields: [
    "Data Delivery Date",
    "Due Date",
    "Data Period Start Date",
    "Data Period End Date",
    "Financial Year End Date",
    "Data Receive Date",
  ],
  contributorFields: [
    "Main Audit Team Contact",
    "Additional Engagement Partner",
    "Preparer",
    "Reviewer",
    "Approver",
    "Onshore Preparer",
    "Onshore Reviewer",
    "Additional DID Team Member",
  ],
};

export const orderFieldsNonConfirmedDetailed = [
  // Main Fields
  {
    type: "textbox",
    section: "main",
    fieldKey: "entityName",
    fieldLabel: "Entity Name",
    value: "JMS FY25 Integrated Audit",
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "engagementCode",
    fieldLabel: "Engagement Code",
    value: "60001590",
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "activityId",
    fieldLabel: "Activity ID",
    value: "0000",
  },
  {
    type: "dropdown",
    section: "main",
    fieldKey: "analyserType",
    fieldLabel: "Analyser Type",
    value: "GLA",
    values: ["GLA", "JEA", "PBC", "FCTA", "GVA"],
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "periodOfTesting",
    fieldLabel: "Period of Testing",
    value: "FY2025 Q1-Q4",
  },
  {
    type: "dropdown",
    section: "main",
    fieldKey: "erpName",
    fieldLabel: "ERP Name",
    value: "SAP S/4HANA",
    values: [
      "SAP S/4HANA",
      "Oracle EBS",
      "Microsoft Dynamics 365",
      "NetSuite",
      "Workday",
      "JD Edwards",
    ],
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "erpVersion",
    fieldLabel: "ERP Version",
    value: "2023",
  },
  {
    type: "dropdown",
    section: "main",
    fieldKey: "dataProcessingTeam",
    fieldLabel: "Data Processing Team",
    value: "Team A",
    values: ["Team A", "Team B", "Team C", "Team D", "Team E"],
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "dataProcessingServerLocation",
    fieldLabel: "Data Processing Server location",
    value: "US East",
  },
  {
    type: "textbox",
    section: "main",
    fieldKey: "analyzerServerLocation",
    fieldLabel: "Analyzer Server Location",
    value: "US West",
  },
  // Date Fields
  {
    type: "date",
    section: "date",
    fieldKey: "dataDeliveryDate",
    fieldLabel: "Data Delivery Date",
    value: "2025-01-15",
  },
  {
    type: "date",
    section: "date",
    fieldKey: "dueDate",
    fieldLabel: "Due Date",
    value: "2025-02-28",
  },
  {
    type: "date",
    section: "date",
    fieldKey: "dataPeriodStartDate",
    fieldLabel: "Data Period Start Date",
    value: "2024-01-01",
  },
  {
    type: "date",
    section: "date",
    fieldKey: "dataPeriodEndDate",
    fieldLabel: "Data Period End Date",
    value: "2024-12-31",
  },
  {
    type: "date",
    section: "date",
    fieldKey: "financialYearEndDate",
    fieldLabel: "Financial Year End Date",
    value: "2024-12-31",
  },
  {
    type: "date",
    section: "date",
    fieldKey: "dataReceiveDate",
    fieldLabel: "Data Receive Date",
    value: "2025-01-10",
  },
  // Contributor Fields
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "mainAuditTeamContact",
    fieldLabel: "Main Audit Team Contact",
    value: "John Smith",
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "additionalEngagementPartner",
    fieldLabel: "Additional Engagement Partner",
    value: "Jane Doe",
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "preparer",
    fieldLabel: "Preparer",
    value: "Mike Johnson",
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "reviewer",
    fieldLabel: "Reviewer",
    value: "Sarah Williams",
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "approver",
    fieldLabel: "Approver",
    value: "Robert Brown",
  },
  {
    type: "dropdown",
    section: "contributor",
    fieldKey: "onshorePreparer",
    fieldLabel: "Onshore Preparer",
    value: "Emily Davis",
    values: [
      "Emily Davis",
      "John Smith",
      "Sarah Johnson",
      "Michael Chen",
      "Lisa Anderson",
      "David Miller",
    ],
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "onshoreReviewer",
    fieldLabel: "Onshore Reviewer",
    value: "David Miller",
  },
  {
    type: "textbox",
    section: "contributor",
    fieldKey: "additionalDidTeamMember",
    fieldLabel: "Additional DID Team Member",
    value: "Lisa Anderson",
  },
];

export let orderFields = orderFieldsNonConfirmed;
export let orderFieldsDetailed = orderFieldsNonConfirmedDetailed;
